/** Strip all whitespace and lowercase — same rules as server auth. */
export function normalizeEmailInput(value: string): string {
  return value.replace(/\s+/g, '').toLowerCase();
}
